

import { DisabledPrompt, Link } from "@bcm-dev/bcms-vite";
import { UIAmountInput, UICheckbox } from "components/ui";
import React from "react";
import { SVGAsset } from "res";

/**
 * @function MobileACHTransfersToTableRow
 * @param {STRING} nickname - Sets the ACH account nickname text. 
 * @param {STRING} amount - Sets the ACH dollar amount for text input.
 * @return {React.Component}
 * @exported true
 * @description - This is the table row used for the mobile One Time ACH To table view.
 */
export default function MobileACHTransfersToTableRow(props) {
    const achToParticipant = props.achToParticipant ?? {};
    const participant = achToParticipant.participant ?? {};
    const onACHToParticipantChange = props.onACHToParticipantChange ?? (() => {});
    const onACHToParticipantDelete = props.onACHToParticipantDelete ?? (() => {});
    const nickname = props.nickname ?? "[nickname]";
    const amount = props.amount ?? "[amount]";
    const addenda = props.addenda ?? "[0]";
    const showHoldPrenoteDistributionColumns = props.showHoldPrenoteDistributionColumns ?? false;
    const isCheckingAcct = participant.accountType === "Checking" ? true: false;

    return (
        <div className="mobile-one-time-ach-to-row">
            <div className="flex-container align-center">
                <div className="flex-width">
                    <div className="detail-row">
                        <span className="detail-label">Nickname</span> <span className="detail-text">{ participant.nickname }</span>
                    </div>
                    <div className="detail-input-row">
                        <div className="flex-container flex-horizontal align-center">
                            <div className="flex-width detail-input">
                                <UIAmountInput value={ achToParticipant.amount.amount } onChange={ onACHToParticipantChange("amount", achToParticipant) } />
                            </div>
                            <div className="set-width text-right detail-actions">
                                { isCheckingAcct && 
                                    <DisabledPrompt>
                                        <SVGAsset id="EditIcon" className="edit-icon clickable" />
                                    </DisabledPrompt>
                                }
                                    <a onClick={ onACHToParticipantDelete(achToParticipant) }>
                                    <SVGAsset id="TrashcanXIcon" className="trash-can-x-icon clickable" />
                                </a>
                            </div>
                        </div>
                        { showHoldPrenoteDistributionColumns && 
                        <>
                            <div className="flex-container flex-horizontal align-center">
                                { isCheckingAcct && <UICheckbox label="Hold" value={ achToParticipant.hold } onChange={ onACHToParticipantChange("hold", achToParticipant) } /> }
                                <UICheckbox label="Prenote" value={ achToParticipant.prenote } onChange={ onACHToParticipantChange("prenote", achToParticipant) } />
                            </div>
                        </>
                        }
                    </div>
                    <div className="detail-addenda-row">
                        <DisabledPrompt>
                            <Link>{ achToParticipant.addenda } Addenda</Link>
                        </DisabledPrompt>
                    </div>
                </div>
            </div>
        </div>
    )
}
